






























import { Component, Mixins } from "vue-property-decorator";
import AdminBrandId from "@/mixins/adminBrandId";

@Component({
  components: {
    "baskets-table": () =>
      import("@/components/app/global/baskets/basketsTable.vue"),
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue")
  }
})
export default class AdminBaskets extends Mixins(AdminBrandId) {
  public get i18n() {
    return {
      add_order: this.$t("_action.add_object", {
        object: (this.$t("_.order") as string).toLowerCase()
      })
    };
  }
}
